import { render, staticRenderFns } from "./RefundList.vue?vue&type=template&id=f5ae70b6&"
import script from "./RefundList.vue?vue&type=script&lang=ts&"
export * from "./RefundList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports